import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

export type ControlDefinition = {
  name: string;
  control: AbstractControl;
};

export function addMissingControls(form: FormGroup, controls: ControlDefinition[]): void {
  controls.forEach(({ name, control }) => {
    if (!form.get(name)) {
      form.addControl(name, control);
    }
  });
}

export function isTouchedAndInvalid(control: AbstractControl): boolean | null {
  return control.invalid && control.touched ? true : null;
}

export function markControlsAsTouched(form: FormGroup): void {
  Object.values(form.controls).forEach((control) => control.markAsTouched());
}

export function resetControl(control: AbstractControl | null, value: unknown = null): void {
  (control as FormControl | null)?.setValue(value);
}
